import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Icon } from "@shared/components";
import { EmptyScreen } from "@shared/components/Page";
import { checkIfAdmin } from "@shared/utils/ACL";
import { selectors as PayPerLeadSelectors } from "@containers/PayPerLead/store";

export const NoFilteredLead: FC = () => {
  const isAdmin = checkIfAdmin();
  const hasActiveSubscription = useSelector(PayPerLeadSelectors.hasActiveSubscription);

  if (isAdmin) {
    return (
      <EmptyScreen>
        <EmptyScreen.Figure>
          <Icon type="empty-leads" />
        </EmptyScreen.Figure>
        <EmptyScreen.Title>No Leads</EmptyScreen.Title>
        <EmptyScreen.Subtitle>
          There are no leads that match the selected filters. Try to select other client, state, or county.
        </EmptyScreen.Subtitle>
      </EmptyScreen>
    );
  }

  return (
    <EmptyScreen>
      <EmptyScreen.Figure>
        <Icon type="empty-screen" />
      </EmptyScreen.Figure>
      <EmptyScreen.Title>
        {hasActiveSubscription ? "Hang tight, leads are on the way!" : "No subscription"}
      </EmptyScreen.Title>
      <EmptyScreen.Subtitle>
        {hasActiveSubscription
          ? "It may take a few days for leads to begin populating. You will receive an email as soon as your lead flow begins!"
          : "To start receiving leads please create or renew existing subscription."}
      </EmptyScreen.Subtitle>
    </EmptyScreen>
  );
};
